import React from 'react';
import Popup from 'reactjs-popup';
import guideIcon from './guidePopupIcon.svg';
import './GuidePopup.css';

const GuidePopup = ({ info = 'Instruction Guide', externalLink = '' }) => {
  const InfoIcon = (
    <a href={externalLink} target="_blank" rel="noopener noreferrer">
      <img
        width={22}
        height={24}
        src={guideIcon}
        alt="Guide icon"
        className="info-popup-icon"
        style={{ cursor: 'pointer' }}
      />
    </a>
  );

  return (
    <Popup
      on="hover"
      trigger={() => InfoIcon}
      position="bottom center"
      closeOnDocumentClick
      arrow={false}
    >
      <div className="info-popup-content">{info}</div>
    </Popup>
  );
};

export default GuidePopup;
